import { ProcessProcessStatusEnum } from '../../../../db';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

const baseDisplayProcessSchema = z.object({
    kind: z.string(),
});

// used by work instruction processes when work instructions are being displayed in advanced mode
export const advancedProcessDisplaySchema = baseDisplayProcessSchema.extend({
    processName: z.string(),
    kind: z.literal('advanced'),
    failedCount: z.number().min(0),
    requiredCount: z.number().min(0),
    completedCount: z.number().min(0),
    status: z.enum([
        ProcessProcessStatusEnum.Completed,
        ProcessProcessStatusEnum.Deleted,
        ProcessProcessStatusEnum.Failed,
        ProcessProcessStatusEnum.Incomplete,
        ProcessProcessStatusEnum.Invalidated,
        ProcessProcessStatusEnum.ManuallyCompleted,
        ProcessProcessStatusEnum.NotRequired,
        ProcessProcessStatusEnum.Pending,
        ProcessProcessStatusEnum.Skipped,
        ProcessProcessStatusEnum.SolveFailed,
    ]),
});

const simpleDisplayProcessSchema = baseDisplayProcessSchema.extend({
    kind: z.literal('simple'),
    processCollectNodeId: z.string(),
});

export const displayProcessCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('displayProcess'),
    attrs: cellCfgAttrsBaseSchema.extend({
        processData: z.discriminatedUnion('kind', [
            advancedProcessDisplaySchema,
            simpleDisplayProcessSchema,
        ]),
    }),
});
